import React from 'react';
import { Route } from 'react-router';
import Routes from 'routes';
import ReportExportModal from './ReportExportModal/ReportExportModal';
import ReportExportModalSuccess from './ReportExportModalSuccess/ReportExportModalSuccess';
import ReportExportModalFail from './ReportExportModalFail/ReportExportModalFail';
import ReportChangeCategoryModal from './ReportChangeCategoryModal/ReportChangeCategoryModal';
import ReportChangeCategoryModalSuccess from './ReportChangeCategoryModalSuccess/ReportChangeCategoryModalSuccess';
import ReportChangeCategoryModalFail from './ReportChangeCategoryModalFail/ReportChangeCategoryModalFail';
import ReportDeleteModal from './ReportDeleteModal';
import ReportDeleteModalSuccess from './ReportDeleteModalSuccess';
import ReportDeleteModalFail from './ReportDeleteModalFail';
import ReportRecurringTransactionsModal from './ReportRecurringTransactionsModal';

const ReportModals: React.FC = () => {
  return (
    <>
      <Route
        path={Routes.REPORT_MODAL_EXPORT}
        exact
        component={ReportExportModal}
      />
      <Route
        path={Routes.REPORT_MODAL_EXPORT_SUCCESS}
        exact
        component={ReportExportModalSuccess}
      />
      <Route
        path={Routes.REPORT_MODAL_EXPORT_FAIL}
        exact
        component={ReportExportModalFail}
      />
      <Route
        path={Routes.REPORT_MODAL_DELETE}
        exact
        component={ReportDeleteModal}
      />
      <Route
        path={Routes.REPORT_MODAL_DELETE_SUCCESS}
        exact
        component={ReportDeleteModalSuccess}
      />
      <Route
        path={Routes.REPORT_MODAL_DELETE_FAIL}
        exact
        component={ReportDeleteModalFail}
      />
      <Route
        path={Routes.REPORT_MODAL_CHANGE_CATEGORY}
        exact
        component={ReportChangeCategoryModal}
      />
      <Route
        path={Routes.REPORT_MODAL_CHANGE_CATEGORY_SUCCESS}
        exact
        component={ReportChangeCategoryModalSuccess}
      />
      <Route
        path={Routes.REPORT_MODAL_CHANGE_CATEGORY_FAIL}
        exact
        component={ReportChangeCategoryModalFail}
      />
      <Route
        path={`${Routes.REPORT_MODAL_RECURRING_TRANSACTIONS}/:type/:id`}
        exact
        component={ReportRecurringTransactionsModal}
      />
    </>
  );
};

export default ReportModals;
